// extracted by mini-css-extract-plugin
export var aiStarIcon = "_b8-4";
export var closeButton = "_b8-6";
export var dismissButton = "_b8-3";
export var editImageWithAiContainer = "_b8-8";
export var imageUploadWrapper = "_b8-7";
export var misspelledWord = "_b8-5";
export var spellCheckContainer = "_b8-2";
export var spin = "_b8-1";
export var spinning = "_b8-0";